export default __webpack_public_path__ + "static/media/excel.c5b06e1b.svg";